import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav, MatDrawerToggleResult } from '@angular/material/sidenav';
import { Subscription, Observable, map } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'apps/driver-dashboardfe/src/app/core/services/authentication/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';
import { UserDataService } from 'apps/driver-dashboardfe/src/app/core/services/user-data/user-data.service';

const maxWidthForSideNav = 1024;

@Component({
    standalone: false,
    selector: 'octo-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    animations: [
        trigger('bodyExpansion', [
            state('collapsed', style({ height: '0px', display: 'none' })),
            state('expanded', style({ height: '*', display: 'block' })),
            transition(
                'expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
            ),
        ]),
    ],
})
export class LayoutComponent implements OnInit, OnDestroy {
    @ViewChild(MatSidenav) sidenav: MatSidenav;
    loading = false;
    isLoading = new Subscription();
    isNavbarOpened = false;
    isSmallScreen: Observable<boolean>;
    cookieName: any = environment.COOKIE_NAME;
    private sideNavOnInitialLoad = new Subscription();
    userSummary$ = new Subscription();
    userSummary: any;

    constructor(
        breakPoints: BreakpointObserver,
        private authService: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router,
        private cookieService: CookieService,
        private userDataService: UserDataService
    ) {
        this.isSmallScreen = breakPoints
            .observe(`(max-width: ${maxWidthForSideNav}px)`)
            .pipe(map((breakpoint) => breakpoint.matches));
    }

    ngOnInit(): void {
        this.userSummary$ = this.userDataService
            .getUserSummary()
            .subscribe((data: any) => {
                this.userSummary = data;
            });
        this.sideNavOnInitialLoad = this.isSmallScreen.subscribe(
            (shouldCloseSideNav) => {
                if (this.sidenav) {
                    this.isNavbarOpened = !shouldCloseSideNav;
                }
            }
        );
    }

    onMenuSelect(): void {
        if (this.sidenav.mode === 'over') {
            this.sidenav.toggle();
        }
    }

    ngOnDestroy(): void {
        this.sideNavOnInitialLoad.unsubscribe();
        this.isLoading.unsubscribe();
    }

    toggleSidenav(sidenav: MatSidenav): Promise<MatDrawerToggleResult> {
        return sidenav.toggle();
    }
}
